import { Form, Formik } from "formik";
import React, { useState } from "react";
import CustomField from "../../components/common/customField";
import { optionsForModeOfPayment } from "../../components/common/utlity/options";
import { initialValuesForCashBook } from "../../components/common/utlity/intialValues";
import { TextField } from "@mui/material";
import { onlyNumber } from "../../helpers/formats";
import { useDispatch } from "react-redux";
import BeatLoader from "react-spinners/BeatLoader";
import { validationSchemaCashbook } from "../../components/common/utlity/validationSchema";
import {
  addTransaction,
  updateCashbook,
} from "../../services/cashbook.services";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { getCurrentDate } from "../../components/common/utlity/utility";
import { getCashBookData } from "../../store/actions/action";
import { useParams } from "react-router-dom";
import { AWS_URL } from "../../services/http.service";

const CashIn = ({ close, item = null, businessUuid }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { bussinessUuid: paramUuid } = useParams();
  const finalBusinessUuid = businessUuid || paramUuid;

  const [itemphoto, setItemphoto] = useState(null);
  const [cashInIsLoading, setCashInIsLoading] = useState(false);

  const handleChangeforFile = (e, values, setFieldValue) => {
    const selectedFile = e.target.files[0];
    setItemphoto(selectedFile);
  };
  const onSubmit = async (e, values, formikHelpers = {}) => {
    const { resetForm } = formikHelpers;
    if (!finalBusinessUuid) {
      toast.error("Business UUID is missing");
      return;
    }

    const dataForSave = new FormData();
    dataForSave.append("amount", values.amount);
    dataForSave.append("paymentMode", values.paymentMode);
    dataForSave.append("transactionType", e);
    dataForSave.append("description", values.description);
    dataForSave.append(
      "transactionDate",
      values.transactionDate || getCurrentDate()
    );
    dataForSave.append("transactionName", values.transactionName);
    dataForSave.append("avatar", itemphoto);

    try {
      if (item) {
        setCashInIsLoading(true);
        const response = await updateCashbook(
          finalBusinessUuid,
          item.transactionId,
          dataForSave
        );

        if (response.status === 200) {
          toast.success(t("MESSAGE.DATA_UPDATED_SUCCESSFULLY"));
          dispatch(getCashBookData(finalBusinessUuid));
          close(true);
        } else {
          throw new Error("Something went wrong during update!");
        }
      } else {
        setCashInIsLoading(true);
        const result = await addTransaction(finalBusinessUuid, dataForSave);

        if (result.status === 201) {
          toast.success(t("MESSAGE.TRANSACTION_ADDED_SUCCESSFULLY"));
          dispatch(getCashBookData(finalBusinessUuid));
          resetForm?.(); // Safe call with optional chaining
          close();
        } else if (result?.response?.status === 400) {
          throw new Error(result.response.data.message);
        } else {
          throw new Error(
            result?.data?.message || "Something went wrong during creation!"
          );
        }
      }
    } catch (error) {
      toast.error(error.message);
      console.error("Error:", error);
    } finally {
      setCashInIsLoading(false);
    }
  };

  // const handleChangeforFile = (e, setFieldValue) => {
  //   const selectedFile = e.target.files[0];
  //   console.log("LINE NO 19", selectedFile);
  // };
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValuesForCashBook(item ? item : null)}
      validationSchema={validationSchemaCashbook}
    >
      {(formik) => {
        const {
          errors,
          values,
          touched,
          handleBlur,
          handleChange,
          setFieldValue,
        } = formik;
        return (
          <Form>
            <div className='container mx-auto bg-gray-100'>
              <div className='grid gap-4 grid-cols-1'>
                <div className='border border-2 border-bold rounded p-4 bg-white dark:bg-[#170f2a] dark:border-gray-300 dark:text-white'>
                  <div className='grid grid-cols-2'>
                    <div className='p-2 col-span-1'>
                      <CustomField
                        type='text'
                        name='amount'
                        label={t("DASHBOARD_NEW_NAME.AMOUNT")}
                        placeholder='Amount'
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        value={values.amount}
                        error={errors.amount}
                        touched={touched.amount}
                        onKeyPress={onlyNumber}
                      />
                    </div>
                    <div className='p-2 col-span-1'>
                      <CustomField
                        type='select'
                        name='paymentMode'
                        label={t("CASHBOOK.MODE_OF_PAYMENT")}
                        handleChange={handleChange}
                        options={optionsForModeOfPayment}
                        value={values.paymentMode}
                        setFieldValue={setFieldValue}
                      />
                    </div>
                    <div className='p-2 col-span-1'>
                      <CustomField
                        type='date'
                        name='transactionDate'
                        label={t("FORM.TRANSACTION_DATE")}
                        placeholder='Transaction Date'
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        value={values.transactionDate}
                        error={errors.transactionDate}
                        touched={touched.transactionDate}
                      />
                    </div>
                    <div className='p-2 col-span-1'>
                      <CustomField
                        type='text'
                        name='transactionName'
                        label={t("CASHBOOK.TRANSACTIONAME")}
                        placeholder='Transaction Name'
                        handleChange={handleChange}
                        value={values.transactionName}
                      />
                    </div>
                  </div>

                  <div className='gap-3 grid grid-cols-2 mt-3'>
                    <div className='p2 col-span-1'>
                      <TextField
                        id='description'
                        name='description'
                        label={t("CASHBOOK.DESCRIPTION")}
                        placeholder='Enter Description'
                        onChange={handleChange}
                        multiline
                        rows={2}
                        value={values.description}
                        className='w-full'
                        InputProps={{
                          className:
                            "dark:text-white dark:bg-[#1f2937] dark:border-white focus:border-blue-600",
                        }}
                        InputLabelProps={{
                          className: "dark:text-white",
                        }}
                      />
                    </div>
                    {/* <div className=''>
                      <CustomField
                        type='file'
                        name='itemPicture'
                        placeholder='Item Picture'
                        handleChange={(e) =>
                          handleChangeforFile(e, setFieldValue)
                        }
                        value={values.itemphoto ? values.itemphoto.name : ""}
                        uploadFiletext='Upload  Image'
                        extraClass='p-7'
                      />
                    </div> */}
                    <div className=''>
                      {item && item.document ? (
                        <div className='w-full flex'>
                          <div className='w-1/3 mr-1'>
                            <div
                              className='items-center '
                              // onClick={() => console.log("clik")}
                            >
                              <img
                                src={AWS_URL + item.document}
                                alt='item'
                                className='h-20'
                              />
                            </div>
                          </div>
                          <div className='w-2/3'>
                            <CustomField
                              type='file'
                              name='itemPicture'
                              placeholder='Item Picture'
                              handleChange={handleChangeforFile}
                              value={
                                values.itemphoto ? values.itemphoto.name : ""
                              }
                              uploadFiletext={
                                itemphoto
                                  ? `${itemphoto?.name}`
                                  : t("FORM.UPLOAD_OTHER_PICTURE")
                              }
                              extraClass='p-7'
                            />
                          </div>
                        </div>
                      ) : (
                        <CustomField
                          type='file'
                          name='itemPicture'
                          placeholder='Item Picture'
                          handleChange={handleChangeforFile}
                          value={values.itemphoto ? values.itemphoto.name : ""}
                          uploadFiletext={
                            itemphoto ? itemphoto?.name : "Upload Product Image"
                          }
                          extraClass='p-7'
                        />
                      )}
                    </div>
                  </div>

                  <div className='grid grid-cols-2 gap-4 mt-4'>
                    <button
                      type='button'
                      className={`w-full py-2 px-2 mt-4 font-bold rounded text-white ${
                        item && item.transactionType === "cash_in"
                          ? "bg-gray-500 hover:bg-gray-400"
                          : "bg-red-500 hover:bg-red-400"
                      }`}
                      onClick={() => onSubmit("cash_out", values)}
                      disabled={
                        (item && item.transactionType === "cash_in") ||
                        cashInIsLoading
                      }
                    >
                      {cashInIsLoading ? (
                        <BeatLoader
                          size={8}
                          color='#ffffff'
                          loading={cashInIsLoading}
                        />
                      ) : item && item.transactionType === "cash_out" ? (
                        t("CASHBOOK.UPDATE_CASH_OUT")
                      ) : (
                        t("CASHBOOK.CASH_OUT")
                      )}
                    </button>

                    <button
                      type='button'
                      className={`w-full py-2 px-2 mt-4 font-bold rounded text-white ${
                        item && item.transactionType === "cash_out"
                          ? "bg-gray-500 hover:bg-gray-400"
                          : "bg-green-500 hover:bg-green-400"
                      }`}
                      onClick={() => onSubmit("cash_in", values)}
                      disabled={
                        item?.transactionType === "cash_out" && cashInIsLoading
                      }
                    >
                      {cashInIsLoading ? (
                        <BeatLoader
                          size={8}
                          color='#ffffff'
                          loading={cashInIsLoading}
                        />
                      ) : item && item.transactionType === "cash_in" ? (
                        t("CASHBOOK.UPDATE_CASH_IN")
                      ) : (
                        t("CASHBOOK.CASH_IN")
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
export default CashIn;
